import React, { useEffect } from 'react';
import * as debounce from 'lodash.debounce';
import { connect, useDispatch } from 'react-redux';
import QuickSearch from '../Components/QuickSearch';
import { query, setSearchQuery, toggleQuickSearchActive, handleKeyDown } from '../Actions/QuickSearch.action';
import { addOverlay, removeOverlay } from "../Actions/Overlay.action"

const QuickSearchContainer = props => {
    const { query, active } = props
    const searchUrl = window.__litium.quickSearchUrl + (query.length > 0 ? `?q=${query}` : '')
    const dispatch = useDispatch()

    useEffect(() => {
        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('q')) {
            const query = urlParams.get('q');
            const { setSearchQuery } = props;
            setSearchQuery(query);
        }
    }, [])

    useEffect(() => {
        if (active) {
            if (!props.algoliaSettings.isActive) {
                document.body.classList.add("no-scroll")
            }
            document.getElementById("header-container").classList.add("hide-nav-elements");
            if (document.getElementById('thin-banner-message')) {
                document.getElementById('thin-banner-message').classList.add("hidden");
            }
        } else {
            document.body.classList.remove("no-scroll");
            document.getElementById("header-container").classList.remove("hide-nav-elements");
            if (document.getElementById('thin-banner-message')) {
                document.getElementById('thin-banner-message').classList.remove("hidden");
            }
        }
    }, [active])

    return <QuickSearch {...props} searchUrl={searchUrl} />
}

const mapStateToProps = state => {
    return state.quickSearch
}

// debouncing function to 200ms so we don't send query request on every key stroke
const debouncedQuery = debounce((dispatch, text) => dispatch(query(text)), 200);

const mapDispatchToProps = dispatch => {
    return {
        onSearch: (text) => {
            dispatch(setSearchQuery(text));
            debouncedQuery(dispatch, text);
        },
        toggleQuickSearchActive: () => dispatch(toggleQuickSearchActive()),
        setSearchQuery: (text) => dispatch(setSearchQuery(text)),
        onKeyDown: (event, opt) => dispatch(handleKeyDown(event, opt)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuickSearchContainer);